import React from 'react';
import wb0 from '../img/Detail/car_details.jpg';
import './Detail.css';
const CarDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Car" />
    </div>
    
  );
};

export default CarDetail;